import axios from 'axios';

const axiosInstance = () => axios.create({
  baseURL: window.location.origin,
});

const methods = {
  getAccessoriesItems: (formData) => axiosInstance().post('/api/accessories/products/', formData),
  getDiscount: () => axiosInstance().get('/api/loyalty/user/discount/'),
};

export default methods;
